'use client';

import InfoIcon from '@mui/icons-material/Info';
import SyncIcon from '@mui/icons-material/Sync';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import React from 'react';

export const SyncButton = ({ syncingRowId, id, isUpdating, toolTipInfo, onClick, disabled, cacheType }) => {
	if (syncingRowId === id) {
		return <CircularProgress />;
	}
	if (isUpdating) {
		return (
			<Tooltip title={toolTipInfo}>
				<InfoIcon />
			</Tooltip>
		);
	}
	return (
		<Tooltip title={`Sync ${cacheType} in cache`}>
			<IconButton disabled={disabled} onClick={onClick}>
				<SyncIcon />
			</IconButton>
		</Tooltip>
	);
};
